module.exports = __webpack_public_path__ + "static/1-INTRODUCING-THE-FLEXIVERSE-8b550f61d3d669be3ff21a0219ed169f.png";